export const organizationOptions = [
	{
		value: 'university',
		label: 'University',
	},
	{
		value: 'school',
		label: 'School',
	},
	{
		value: 'independent-organization',
		label: 'Independent Organization',
	},
];
